import GlobalStateContainer from '@containers/GlobalStateContainer';
import { CookiesProvider } from 'react-cookie';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { PreviewMediaProvider } from './contexts/PreviewMediaContext';
import Router from './modules/router/views/Router';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function App() {
  return (
    <CookiesProvider>
      <GlobalStateContainer.Provider>
        <QueryClientProvider client={queryClient}>
          <PreviewMediaProvider>
            <Router />
          </PreviewMediaProvider>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </GlobalStateContainer.Provider>
    </CookiesProvider>
  );
}

export default App;
